import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bmwicon_personal",
  "use": "icon-bmwicon_personal-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-bmwicon_personal\"><path d=\"M25.51,13.47A5.58,5.58,0,1,0,19.94,19,5.58,5.58,0,0,0,25.51,13.47ZM33.8,6.2A19.53,19.53,0,1,0,39.51,20,19.42,19.42,0,0,0,33.8,6.2ZM29.59,30.94a.87.87,0,0,1-.87-.87,8.78,8.78,0,1,0-17.56,0,.87.87,0,0,1-1.74,0,10.54,10.54,0,0,1,7.24-10,7.39,7.39,0,1,1,6.55,0,10.53,10.53,0,0,1,7.25,10A.87.87,0,0,1,29.59,30.94Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol